/**
 * User onboarding statuses
 *
 * Handles sending and validating phone verification codes.
 *
 * Endpoints:
 *   GET /api/users/onboarding         — Get list of onboardings the users did
 *   POST /api/users/onboarding        - Mark an onboarding as done
 */
import { createApiWithNewBasePath as api } from "@api";


export const getOnboardingStatuses = () =>
  api.get('users/onboarding_status')

export const createOnboardingStatus = (onboardingStatus: string) =>
  api.post('users/onboarding_status', { onboarding_status: onboardingStatus })

